import { useLocalization } from "@fluent/react";
import { useDashboardLayoutRedesignEnabled, useFeature } from "byzantine";
import { useBreakpoints } from "@narmi/design_system";
import BaseBanner from "../BaseBanner";
import { QuickActionsBarContainer } from "../quick_actions";
import { useCurrentUser } from "../contexts/CurrentUserContext";
import OnboardingCard from "./OnboardingCard";

const DashboardHeader = () => {
  const { l10n } = useLocalization();
  const { features } = useFeature();
  const { currentUser } = useCurrentUser();
  const { l } = useBreakpoints();
  const isDashboardLayoutRedesignEnabled = useDashboardLayoutRedesignEnabled();
  const userName =
    currentUser?.org_name || currentUser?.getShortDescription() || "";

  return (
    <>
      <BaseBanner
        bannerName={l10n.getString("dashboard-welcome", { userName })}
        buttonFunction={() => window.location.assign("/transfer/")}
        buttonName={l10n.getString("button-transfer", null, "Transfer funds")}
        orFeatureFlagChecks={["transfers"]}
        features={features}
      />
      <QuickActionsBarContainer />
      {l && isDashboardLayoutRedesignEnabled && <OnboardingCard />}
    </>
  );
};

export default DashboardHeader;
